export default "__VITE_ASSET__fWF7X_JD__"